import axiosInstance from '../api/axios';


// Function to get all students
export const getAllThesis = async () => {
    try {
        const response = await axiosInstance.get('/thesis');
        return response.data;
    } catch (error) {
        console.error('Error fetching students:', error);
        throw error;
    }
};

export const getAllThesisAssigned = async (id) => {
    try {
        const response = await axiosInstance.get(`/thesisAssigned?id=${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching students:', error);
        throw error;
    }
};
export const getStudentThesis = async (id) => {
    try {
        const response = await axiosInstance.get(`/getThesisByStudentId?id=${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching students:', error);
        throw error;
    }
};

export const getAllMentorStudents = async (id) => {
    try {
        const response = await axiosInstance.get(`/getThesisByMentorId?id=${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching students:', error);
        throw error;
    }
};


export const getFeedbackById = async (id) => {
    try {
        const response = await axiosInstance.get(`/getThesisFeedbackById?id=${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching students:', error);
        throw error;
    }
};